<template>
  <div class="teen-page teen5">
    <div class="header">
      <h1>四大发明：中华文明的瑰宝</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_5.png" alt="四大发明">
        <div class="caption">中国古代四大发明：造纸术、印刷术、火药、指南针</div>
      </div>

      <h2>一、 造纸术</h2>
      <p>造纸术是中国古代最重要的发明之一。东汉时期，蔡伦改进了造纸工艺，使用树皮、破布等廉价原料制造纸张。纸张的发明极大地促进了知识的传播和保存，对人类文明的发展产生了深远影响。</p>

      <h2>二、 印刷术</h2>
      <p>印刷术的发明是人类文明史上的重要里程碑。从早期的雕版印刷到北宋毕昇发明的活字印刷术，印刷技术不断发展。印刷术使得书籍能够大量复制，知识得以广泛传播。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_5.png" alt="古代印刷术">
        <div class="caption">古代印刷作坊，活字印刷的诞生地</div>
      </div>

      <h2>三、 火药</h2>
      <p>火药是中国古代炼丹家在炼制丹药时偶然发现的。最初用于制作烟花爆竹，后来被应用于军事领域。火药的发明改变了战争的方式，对世界军事史产生了重大影响。</p>

      <h2>四、 指南针</h2>
      <p>指南针是中国古代最重要的导航工具。早在战国时期，中国人就发现了磁石指示南北的特性，并发明了最早的指南针——司南。指南针的发明为航海事业的发展提供了重要保障，推动了世界范围内的海上贸易和探险。</p>

      <div class="quote-box">
        "中国的四大发明改变了整个世界的面貌和状态。" —— 弗朗西斯·培根
      </div>

      <h2>五、 文明的传播</h2>
      <p>四大发明通过丝绸之路等途径传播到世界各地，对人类文明的发展做出了巨大贡献。它们不仅体现了中国古代人民的智慧，也是世界文明宝库中的珍贵财富。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen5'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #fef9e7;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #d4a574 0%, #c4956a 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #8b6914;
  border-bottom: 2px solid #d4a574;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #fdf5e6;
  padding: 20px;
  border-left: 4px solid #d4a574;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>